export function trimArray(arr: string[], cut: number = 3): string[] {
  if (arr.length > cut) {
    return [...arr.slice(0, cut), "..."]
  }
  return arr
}

export function asDate(datetime: string): Date {
  if (!datetime.includes("T")) datetime += "T12:00:00"
  if (!datetime.endsWith("Z")) datetime += "Z"
  return new Date(datetime)
}

/** Converts UTC datetime into local time; returns date as string */
export function localdate(
  datetime?: string | null,
  mode: "default" | "long" | "short" = "default",
): string {
  if (!datetime) return ""
  const d = asDate(datetime)
  const options: Intl.DateTimeFormatOptions = {}
  if (mode === "long") {
    options.month = "long"
    options.day = "numeric"
    options.year = "numeric"
  } else if (mode === "short") {
    options.month = "short"
    options.day = "numeric"
    options.year = "numeric"
  }
  return d.toLocaleDateString("default", options)
}

export function nextSunday(): string {
  const now = new Date()
  return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 7 - now.getDay())
    .toISOString()
    .split("T")[0] as string
}

export function fileToBase64String(file: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      let encoded = reader.result?.toString() || ""
      encoded = encoded.replace(/^data:(.*,)?/, "")
      if (encoded.length % 4 > 0) {
        encoded += "=".repeat(4 - (encoded.length % 4))
      }
      resolve(encoded)
    }
    reader.onerror = reject
  })
}

export function randomId(): string {
  return Math.random().toString(36).slice(2, 9)
}

/**
 * Chord ratio is the ratio of the number of chord-like characters
 *     (upper case, space, number, slash, #, b)
 * in a line to the total number of characters.
 */
export function chordRatio(line: string): number {
  if (line.length === 0) return 0
  const chordCount = (line.match(/[A-Z0-9/#b ]/g) || []).length
  return chordCount / line.length
}

export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export function isMobileSafari() {
  // Source - https://stackoverflow.com/a/29696509
  // Posted by unwitting, modified by community. See post 'Timeline' for change history
  // Retrieved 2026-02-28, License - CC BY-SA 3.0

  var ua = window.navigator.userAgent
  var iOS = !!ua.match(/iP(ad|hone)/i)
  var webkit = !!ua.match(/WebKit/i)
  return iOS && webkit && !ua.match(/CriOS/i)
}

export function timeString(t: number) {
  const h = Math.trunc(t / 3600)
  const m = Math.trunc((t % 3600) / 60)
    .toString()
    .padStart(2, "0")
  const s = Math.trunc(t % 60)
    .toString()
    .padStart(2, "0")
  return `${h}:${m}:${s}`
}
